/*
 * fn: objectEntries
 *
 * A typescript-safe wrapper for Object.entries
 *
 */
type EntriesType<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][]

export const objectEntries = <T extends object>(obj: T): EntriesType<T> =>
  Object.entries(obj) as unknown as EntriesType<T>
